module.exports = __webpack_public_path__ + "4dac0f6.woff2";